var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-link-base",class:{noBorder: _vm.noBorder}},[_c('span',{staticClass:"button-link",class:{disable: _vm.btnDisable},on:{"click":_vm.onBtnClick}},[_c('span',{staticClass:"button-face"},[_vm._v(_vm._s(_vm.buttonFace))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbbba9f8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/partials/SecButtonLink.vue
// module id = null
// module chunks = 